/**
 * 環境変数設定
 *
 * Vite環境変数を管理
 */

export const ENV = {
  REGION: import.meta.env.VITE_AUTH_REGION || "ap-northeast-1",
  // Cognito側のドメイン (umeee-auth-dev.auth.ap-northeast-1.amazoncognito.com)
  COGNITO_DOMAIN: import.meta.env.VITE_COGNITO_DOMAIN,
  COGNITO_USERPOOL_ID: import.meta.env.VITE_COGNITO_USERPOOL_ID,
  CLIENT_ID: import.meta.env.VITE_COGNITO_CLIENT_ID,
  // リダイレクトURL (https://core-platform.devserver.umeee-app.com/vite/callback)
  REDIRECT_URI: import.meta.env.VITE_COGNITO_REDIRECT_URI,
  SCOPES: import.meta.env.VITE_COGNITO_SCOPES ?? "openid email profile",
  // トークンと検証コードの交換用の自前エンドポイント
  AUTH_API_ENDPOINT: import.meta.env.VITE_AUTH_API_ENDPOINT,
  ENV: import.meta.env.VITE_ENV || "", // dev, stg, prod等の環境識別子
} as const;

console.log({ ENV });
